import React, { useState } from "react";
import ActionItemsTable from "./ActionItemsTable";
import useAxios from "axios-hooks";
import { useHistory, useRouteMatch } from "react-router-dom";
import DeleteActionItemModal from "./DeleteActionItemModal";
import { Spinner } from "@fluentui/react";

const ActionItemsList = () => {
  const history = useHistory();
  let { url } = useRouteMatch();

  const [showModal, setHideDialog] = useState(false);
  const [selectedActionItemId, setSelectedActionItemId] = useState(undefined);
  const [selectedActionItemTitle, setSelectedActionItemTitle] = useState("");

  const toggleShowModal = () => {
    setHideDialog((prev) => !prev);
  };

  const [{ data, loading }, refetch] = useAxios("action-items");
  // eslint-disable-next-line no-empty-pattern
  const [{}, executePost] = useAxios(
    {
      method: "post",
    },
    { manual: true }
  );

  if (loading)
    return (
      <Spinner className="absolute-center" label="Loading Action Items..." />
    );

  return (
    <>
      <ActionItemsTable
        actionItems={data}
        setSelectedActionItemId={setSelectedActionItemId}
        setSelectedActionItemTitle={setSelectedActionItemTitle}
        createOnClick={() => history.push(`${url}/basic-info`)}
        cloneOnClick={async (id) => {
          try {
            const response = await executePost({ data: {}, url: `action-item/${id}/clone` });
            const clonedId = response?.data?.actionItemID;
            if (clonedId && typeof clonedId === 'number') {
              history.push(`${url}/${clonedId}/basic-info`);
            } else {
              console.warn('Clone response did not contain actionItemID:', response?.data);
              refetch();
            }
          } catch (e) {
            // Ignore cancellation errors that occur when navigating away
            if (e?.message !== undefined || e?.name === 'CanceledError') {
              console.error('Clone failed:', e);
            }
          }
        }}
        deleteOnClick={(id, title) => {
          setSelectedActionItemId(id);
          setSelectedActionItemTitle(title || "");
          toggleShowModal();
        }}
        editOnClick={(id) => {
          history.push(`${url}/${id}/basic-info`);
        }}
        discoverOnClick={(id) => history.push(`${url}/${id}/discoverability`)}
        refetch={refetch}
        loading={loading}
        selectedActionItemId={selectedActionItemId}
      />
      <DeleteActionItemModal
        actionItemId={selectedActionItemId}
        actionItemTitle={selectedActionItemTitle}
        showModal={showModal}
        toggleShowModal={toggleShowModal}
        onDelete={() => refetch()}
      />
    </>
  );
};

export default ActionItemsList;
